















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

const namespace: string = 'smart';

@Component
export default class Cards extends Vue {
  @Prop(String) private title1: String;
  @Prop(String) private title2: String;
  @Prop(Boolean) private titleClickable: Boolean;
  @Prop(String) private image: String;
  @Prop(String) private picture: String;
  @Prop(String) private backgroundCard: String;

  @Emit('onSmart')
  onSmart() {}
  @Emit('onCardClick')
  onCardClick() {}
}
